import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Contact from "@/pages/Contact";
import MedicalDisclaimer from "@/pages/MedicalDisclaimer";
import Admin from "@/pages/Admin";
import Feedback from "@/pages/Feedback";
import Share from "@/pages/Share";
import Subscribe from "@/pages/Subscribe";
import QrCard from "@/pages/QrCard";
import QrShare from "@/pages/QrShare";
import Go from "@/pages/Go";
import Redirect from "@/pages/Redirect";
import CookieBanner from "@/components/CookieBanner";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/support" element={<Contact />} />
          <Route path="/medical-disclaimer" element={<MedicalDisclaimer />} />
          <Route
            path="/medical_disclaimer"
            element={<Navigate to="/medical-disclaimer" replace />}
          />
          <Route path="/admin" element={<Admin />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/share" element={<Share />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/qr-card" element={<QrCard />} />
          <Route path="/qr-share" element={<QrShare />} />
          <Route path="/go" element={<Go />} />

          {/* Short-link bio redirects — each fires an analytics beacon
              then redirects to the App Store with Apple ct campaign token.
              Update UTMs / ct labels by adding new routes. */}
          <Route path="/ig" element={<Redirect source="instagram" medium="bio" label="ig" ct="ig_bio" />} />
          <Route path="/ig-story" element={<Redirect source="instagram" medium="story" label="ig-story" ct="ig_story" />} />
          <Route path="/fb" element={<Redirect source="facebook" medium="bio" label="fb" ct="fb_bio" />} />
          <Route path="/tt" element={<Redirect source="tiktok" medium="bio" label="tt" ct="tt_bio" />} />
          <Route path="/tw" element={<Redirect source="twitter" medium="post" label="tw" ct="tw_post" />} />
          <Route path="/rd" element={<Redirect source="reddit" medium="post" label="rd" ct="rd_post" />} />
          <Route path="/nl" element={<Redirect source="newsletter" medium="email" label="nl" ct="nl_email" />} />
          <Route path="/qr" element={<Redirect source="qr" medium="print" label="qr" ct="qr_print" />} />

          {/* Bio-link opt-in aliases — deliver visitors to the dedicated
              /subscribe email capture with source pre-tagged for analytics. */}
          <Route path="/ig-subscribe" element={<Navigate to="/subscribe?src=ig" replace />} />
          <Route path="/fb-subscribe" element={<Navigate to="/subscribe?src=fb" replace />} />
          <Route path="/tt-subscribe" element={<Navigate to="/subscribe?src=tt" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            color: "#fff",
            border: "1px solid rgba(255,42,42,0.4)",
            borderRadius: "2px",
          },
        }}
      />
    </div>
  );
}

export default App;
